import React from 'react';
import styled from 'styled-components';

import './App.css';
import { ReactComponent as IconAppleMusic } from './svgs/applemusic.svg';
import { ReactComponent as IconInstagram } from './svgs/instagram.svg';
import { ReactComponent as IconSpotify } from './svgs/spotify.svg';
import { ReactComponent as IconBandCamp } from './svgs/bandcamp.svg';
import { ReactComponent as IconYouTubeMusic } from './svgs/youtubemusic.svg';
import { ReactComponent as IconSoundcloud } from './svgs/soundcloud.svg';
// import backgroundVideo from './assets/background.mp4';


// import VideoBackground from './VideoBackground';
import ImageBackground from './ImageBackground';
import SpotifyEmbed from './SpotifyEmbed';

const Content = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  color: #f1f1f1;
  padding: 20px ;
`

// const TitleImage = styled.img`
//   max-width: 500px;
//   marging: 0 auto;
//   width: 100%;
// `

const SocialContainer = styled.div`
  padding-top: 20px;
  max-width: 500px;
  margin: 0 auto;

`

// const SocialContainerHeader = styled.h2`
//   font-family: t26-carbon, monospace;
//   text-transform: uppercase;
//   font-weight: normal;
// `

const SocialContainerSubHeader = styled.h2`
  font-family: t26-carbon, monospace;
  text-transform: uppercase;
  font-weight: normal;
`

const SocialItemContainer = styled.div`
  display: flex;
`
const SocialItem = styled.a`
  flex: 1;

`

const SocialIcon = styled.div`
  // padding: 20px;

  svg {
    fill: hsla(285deg, 15%, 100%, 95%);
    margin: 20px;
    max-width: 50px;
  }

`

const InstaLinkContainer = styled.a`
  font-family: t26-carbon, monospace;
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  width: 100%;
  padding: 20px 20px 20px 45px;
  text-align: left;

  > div {
    width: 250px;
    margin: 0 auto;
    position: relative;
    padding-left: 50px;
  }

  ${SocialIcon}{
    display: inline-block;
    position: absolute;
    left: 0;

    svg {
      padding: 0;
      margin: 0;
      height: 30px;
      width: 30px;
    }
  }

`

const SoundcloudLinkContainer = styled.a`
  font-family: t26-carbon, monospace;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 20px 20px 20px 45px;
  text-align: left;

  > div {
    width: 250px;
    margin: 0 auto;
    position: relative;
    padding-left: 50px;
  }

  ${SocialIcon}{
    display: inline-block;
    position: absolute;
    left: 0;

    svg {
      padding: 0;
      margin: 0;
      height: 30px;
      width: 30px;
    }
  }

`

const LinkText = styled.span`
  display: inline-block;
  line-height: 30px;

`

function App() {

  // const backgroundVideoSrc = '';
  const backgroundPosterSrc = './assets/background-poster.jpg';


  return (
    <div className="App">
      {/* <VideoBackground src={backgroundVideoSrc} poster={backgroundPosterSrc} /> */}
      <ImageBackground src={backgroundPosterSrc} />

      <Content>
        {/* <TitleImage src="./assets/portals-neverspeak-artwork.jpg" alt="NEVERSPEAK - Portals (New Release)" style={{maxWidth:"350px", marginTop: "20px"}} /> */}
        <SpotifyEmbed uri={'4KnGgVmCsaSoQnTso37Sha'}/>

        <SocialContainer>
          {/* <SocialContainerHeader>Debut Single - Out now</SocialContainerHeader> */}
          <SocialContainerSubHeader>Listen now on:</SocialContainerSubHeader>
          <SocialItemContainer>
            <SocialItem href="https://open.spotify.com/track/4KnGgVmCsaSoQnTso37Sha?si=1fb8cbcc46734e9c" title="Listen on Spotify">
              <SocialIcon>
                <IconSpotify />
              </SocialIcon>
            </SocialItem>
            <SocialItem href="https://music.apple.com/us/album/moneymaker-feat-jedli-single/1729097987" title="Listen on Apple Music">
              <SocialIcon>
                <IconAppleMusic />
              </SocialIcon>
            </SocialItem>
            <SocialItem href="https://music.youtube.com/watch?v=plxZPNj15UI&si=SsZ4gNSGI1a3yXSD" title="Listen on YouTube Music">
              <SocialIcon>
                <IconYouTubeMusic />
              </SocialIcon>
            </SocialItem>
            <SocialItem href="https://neverspeak.bandcamp.com/track/moneymaker-ft-jedli" title="Buy on BandCamp">
              <SocialIcon>
                <IconBandCamp />
              </SocialIcon>
            </SocialItem>

          </SocialItemContainer>

        </SocialContainer>

        <InstaLinkContainer href="https://instagram.com/neverspeakmusic">
          <div>

          <SocialIcon><IconInstagram /></SocialIcon>
          <LinkText>Follow On Instagram</LinkText>
          </div>

        </InstaLinkContainer>

        <SoundcloudLinkContainer href="https://soundcloud.com/neverspeakmusic">
          <div>
            <SocialIcon><IconSoundcloud /></SocialIcon>
            <LinkText>Follow On Soundcloud</LinkText>
          </div>
        </SoundcloudLinkContainer>

      </Content>
    </div>
  );
}

export default App;
